export default __webpack_public_path__ + "static/media/Imagem Main Content-2.4ff6da03.png";